import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLocationFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M10.7188 17.625C10.3438 18.0938 9.625 18.0938 9.25 17.625C7.65625 15.5937 4 10.75 4 8C4 4.6875 6.6875 2 10 2C13.3125 2 16 4.6875 16 8C16 10.75 12.3438 15.5937 10.7188 17.625ZM10 6C9.28125 6 8.625 6.40625 8.25 7C7.90625 7.625 7.90625 8.40625 8.25 9C8.625 9.625 9.28125 10 10 10C10.6875 10 11.3438 9.625 11.7188 9C12.0625 8.40625 12.0625 7.625 11.7188 7C11.3438 6.40625 10.6875 6 10 6Z"
	})
});
const ForwardRef = forwardRef(SvgLocationFilled);
export default ForwardRef;
